import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import Add from "@mui/icons-material/AddCircleOutline";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import Category from "~/libs/category";
import DlsCategoriesList from "./DlsCategoriesList";
import RightSidebarMenuSmall from "./RightSidebarMenuSmall";
import TeachingMaterialList from "./TeachingMaterialList";

const AddIcon = styled(Add)(({ theme }) => ({
  "&.MuiIcon-root": {
    margin: theme.spacing(0, 1),
    fontSize: theme.typography.pxToRem(32)
  }
}));

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
const StyledTabs = styled(Tabs)(props => {
  let backgroundColor = props.theme.palette.mbgreen[0];
  if (props.isDlsActive) {
    backgroundColor = props.theme.palette.mborange[0];
  }
  if (props.isPresentationActive) {
    backgroundColor = props.theme.palette.prblue[1];
  }
  return {
    "&.MuiTabs-root": {
      color: "white"
    },
    "& .MuiTabs-indicator": {
      backgroundColor
    }
  };
});

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
const PublisherTab = styled(Tab)(props => {
  let backgroundColor = props.theme.palette.mbgreen[0];
  if (props.selected) {
    if (props.isDlsActive) {
      backgroundColor = props.theme.palette.mborange[0];
    }
    if (props.isPresentationActive) {
      backgroundColor = props.theme.palette.prblue[1];
    }
  } else {
    backgroundColor = props.theme.palette.grayscale[3];
  }

  return {
    "&.MuiTab-root": {
      backgroundColor,

      height: "2.4rem",
      textTransform: "none",
      minWidth: "initial",
      color: "white !important",
      fontSize: props.theme.typography.pxToRem(16)
    },
    "&:focus-visible": {
      // "--dsb-outline-color": "green",
      outline: props.theme.outline(),
      outlineOffset: "-2px"
    }
  };
});

const AddMaterialButton = styled(Button)(({ theme }) => ({
  "&.MuiButton-root": {
    backgroundColor: theme.palette.mborange[1],
    "&:hover": {
      backgroundColor: theme.palette.mborange[0]
    },
    color: "#ffffff",
    marginTop: theme.spacing(1),
    padding: theme.spacing(4, 0)
  }
}));

const Columns = styled("div")`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex: 1;
`;

const Column = styled("div")`
  float: left;
  width: ${props => props.width};
  height: 100%;
  padding-right: 10px;
  overflow-y: ${props => (props.scrollable ? "auto" : "hidden")};
`;

class RightSidebarContent extends Component {
  static whyDidYouRender = false;

  constructor(props) {
    super(props);

    this.getCurrentTab = this.getCurrentTab.bind(this);
    this.setCurrentTab = this.setCurrentTab.bind(this);
    this.onNewMaterial = this.onNewMaterial.bind(this);
    this.getCurrentCategory = this.getCurrentCategory.bind(this);
    this.setCurrentCategory = this.setCurrentCategory.bind(this);
    this.equalsCurrentCategory = this.equalsCurrentCategory.bind(this);
  }

  getCurrentTab() {
    const { isDlsActive, dlsActiveTab, activeTab } = this.props;

    if (isDlsActive) {
      return dlsActiveTab;
    }

    return activeTab;
  }

  setCurrentTab(event, value) {
    const { isDlsActive, setDlsActiveTab, switchTabOnSidebarRight } = this.props;

    if (isDlsActive) {
      setDlsActiveTab(value);
    } else {
      switchTabOnSidebarRight(value);
    }
  }

  onNewMaterial(event) {
    this.props.showModal("NEW_MATERIAL", {});
  }

  getCurrentCategory() {
    const { dlsActiveCategory } = this.props;
    return dlsActiveCategory;
  }

  setCurrentCategory(category) {
    return event => {
      const { setDlsActiveCategory, isGreaterThanMedium, closeSidebarRight } = this.props;

      setDlsActiveCategory(category.title);

      if (!isGreaterThanMedium) {
        closeSidebarRight();
      }
    };
  }

  equalsCurrentCategory(category) {
    return Category.isEqual(category, this.getCurrentCategory());
  }

  render() {
    const { showMaterialsOnPageTab, showAllMaterialsTab, isEditMode, isDlsActive, isPresentationActive, dlsActiveTab } =
      this.props;

    return (
      <>
        <StyledTabs
          isDlsActive={isDlsActive}
          isPresentationActive={isPresentationActive}
          value={this.getCurrentTab()}
          onChange={this.setCurrentTab}
          variant="fullWidth"
          onKeyDown={event => {
            event.stopPropagation();
          }}
        >
          {showMaterialsOnPageTab && (
            <PublisherTab
              isDlsActive={isDlsActive}
              isPresentationActive={isPresentationActive}
              label="Aktuelle Seite"
              value="page"
            />
          )}

          {showAllMaterialsTab && (
            <PublisherTab
              isDlsActive={isDlsActive}
              isPresentationActive={isPresentationActive}
              label={isDlsActive ? "Allgemein" : "Ganzes Buch"}
              value="all"
            />
          )}
        </StyledTabs>

        {isDlsActive ? (
          <DlsCategoriesList setCurrentCategory={this.setCurrentCategory} dlsActiveTab={dlsActiveTab} />
        ) : (
          <Columns>
            <Column width="25%">
              <RightSidebarMenuSmall />
            </Column>
            <Column scrollable width="75%">
              {isEditMode && (
                <AddMaterialButton color="primary" variant="contained" fullWidth onClick={this.onNewMaterial}>
                  <AddIcon />
                  Material
                </AddMaterialButton>
              )}
              <TeachingMaterialList />
            </Column>
          </Columns>
        )}
      </>
    );
  }
}

RightSidebarContent.propTypes = {
  activeTab: PropTypes.oneOf(["page", "all"]).isRequired,
  switchTabOnSidebarRight: PropTypes.func.isRequired,
  isDlsActive: PropTypes.bool.isRequired,
  dlsActiveTab: PropTypes.oneOf(["page", "all"]).isRequired,
  setDlsActiveTab: PropTypes.func.isRequired,
  dlsActiveCategory: PropTypes.object,
  showModal: PropTypes.func.isRequired,
  setDlsActiveCategory: PropTypes.func.isRequired,
  isGreaterThanMedium: PropTypes.bool.isRequired,
  showMaterialsOnPageTab: PropTypes.bool.isRequired,
  showAllMaterialsTab: PropTypes.bool.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  isPresentationActive: PropTypes.bool.isRequired,
  closeSidebarRight: PropTypes.func.isRequired
};

RightSidebarContent.defaultProps = {
  activeTab: "page"
};

RightSidebarContent.whyDidYouRender = false;

export default RightSidebarContent;
